export default __webpack_public_path__ + "static/media/breach.7b1d9fee.png";